/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type app_v1_account_AccountUpdate = {
    account_category_id?: string | null;
    balance?: number;
    currency?: app_v1_account_AccountUpdate.currency | null;
    name?: string;
};

export namespace app_v1_account_AccountUpdate {

    export enum currency {
        AED = 'AED',
        ANG = 'ANG',
        AUD = 'AUD',
        BGN = 'BGN',
        BMD = 'BMD',
        BRL = 'BRL',
        BWP = 'BWP',
        CAD = 'CAD',
        CHF = 'CHF',
        CLP = 'CLP',
        CNH = 'CNH',
        CNY = 'CNY',
        COP = 'COP',
        CZK = 'CZK',
        DKK = 'DKK',
        EEK = 'EEK',
        EUR = 'EUR',
        GBP = 'GBP',
        GBX = 'GBX',
        HKD = 'HKD',
        HUF = 'HUF',
        IDR = 'IDR',
        ILS = 'ILS',
        INR = 'INR',
        ISK = 'ISK',
        JPY = 'JPY',
        KRW = 'KRW',
        KWD = 'KWD',
        KYD = 'KYD',
        KZT = 'KZT',
        LSL = 'LSL',
        LTL = 'LTL',
        MOP = 'MOP',
        MTL = 'MTL',
        MXN = 'MXN',
        MYR = 'MYR',
        NAD = 'NAD',
        NOK = 'NOK',
        NZD = 'NZD',
        OMR = 'OMR',
        PKR = 'PKR',
        PLN = 'PLN',
        RMB = 'RMB',
        RON = 'RON',
        RUB = 'RUB',
        SEK = 'SEK',
        SGD = 'SGD',
        THB = 'THB',
        TRY = 'TRY',
        TWD = 'TWD',
        USD = 'USD',
        VND = 'VND',
        ZAR = 'ZAR',
    }


}

